import { tuple as vTuple, number as vNumber } from 'valibot'; // destruct to be sure that we don't ship whole valibot library to front
// Keep location format as close to MapBox as possible
export interface Location {
  postcode: string | null
  place: string | null
}

// “_index” will be OpenSearch documents group
// those will be one onf the nuxt config OS location index
// as for now:
// - containing: “adm4” it's an administrative region (can be city, department, region…)
// - containing “pos4” it's a group cities sharing the same postal code
// https://demos.mapbox.com/boundaries-explorer/?country=FR&layer=pos4&worldview=US#6.43/46.757/1.074

export type LocationCentroid = [longitude: number, latitude: number];
export const LocationCentroidSchema = vTuple([vNumber(), vNumber()]);
export interface LocationParent { slug: string, displayName: string }
export interface LocationNeighbor {
  slug: string
  mapboxId: string
  displayName: string
  displayNameWithCode: string
  geoIndex: string
  isGroup: boolean
}

export interface LocationSearchResult {
  index: string
  id: string
  mapboxIds: [string, ...string[]]
  displayName: string
  displayCode: string
  displayNameWithCode: string
  geoIndex: string
  layerName: 'adm1' | 'adm2' | 'adm4' | 'pos4'
  isGroup: boolean
  slug: string
  centroid: LocationCentroid
  unitCode?: string
  parents: Array<LocationParent>
  neighbors: Array<LocationNeighbor>
}

export type LocationApiSearchResult = Pick<LocationSearchResult, 'displayCode' | 'displayName' | 'displayNameWithCode' | 'layerName' | 'slug' | 'isGroup'>;

export interface MinimalLocation {
  displayName: string
  displayNameWithCode?: string
  slug: string
}
